/* eslint-disable */
<template>
  <div>

    <vx-card class="mt-4">
      <!-- SEARCH BAR -->
      <div class="grid gap-4 items-end lg:grid-cols-9 md:grid-cols-1">

        <div>
          <vs-select
            v-model="portfolio"
            label="Data do portfolio"
            class="w-full">
            <vs-select-item :key="index" :value="item" :text="item.portfolioDate" v-for="(item, index) in portfolios" class="w-full"/>
          </vs-select>
        </div>

        <div>
          <vs-select
            v-model="company"
            label="Nome"
            autocomplete
            class="w-full">
            <vs-select-item :key="index" :value="item" :text="item.name" v-for="(item, index) in companies" class="w-full"/>
          </vs-select>
        </div>

        <div>
          <vs-select
            v-model="company"
            label="Cnpj"
            autocomplete
            class="w-full">
            <vs-select-item :key="index" :value="item" :text="(item.cnpjAlfa || item.cnpj) | formatCnpj" v-for="(item, index) in companies" class="w-full"/>
          </vs-select>
        </div>

        <div>
          <vs-select
            v-model="tipoOperacao"
            label="Operação"
            class="w-full">
            <vs-select-item :key="index" :value="item.value" :text="item.name" v-for="(item, index) in tipoOperacoes" class="w-full"/>
          </vs-select>
        </div>

        <div>
          <vs-select
            v-model="energy"
            label="Tipo de Energia"
            class="w-full">
            <vs-select-item :key="index" :value="item.value" :text="item.name" v-for="(item, index) in energyTypes"
                            class="w-full"/>
          </vs-select>
        </div>

        <div>
          <vs-select
            v-model="market"
            label="Submercado"
            class="w-full">
            <vs-select-item :key="index" :value="item.value" :text="item.name" v-for="(item, index) in markets"
                            class="w-full"/>
          </vs-select>
        </div>

        <div>
          <vs-input label="Id Interno"
                    class="w-full"
                    size="normal"
                    v-model="idThunders"
                    @keyup.enter="refine(company, idThunders, energy, market, portfolio)"
                    @keyup.esc="refine(company, idThunders, energy, market, portfolio)"/>
        </div>

        <div>
          <vs-button
            @click="clearFilter()"
            icon-pack="fa"
            icon="fa-eraser"
            title="Limpar"
            class="w-full">
            Limpar
          </vs-button>
        </div>

        <div>
          <vs-button
            @click="refine(company, idThunders, energy, market, portfolio, tipoOperacao)"
            icon="search"
            title="Buscar"
            class="w-full">
            Buscar
          </vs-button>
        </div>

      </div>

    </vx-card>

    <vx-card class="mt-4">
      <energy-balance-chart :values="values" bar-width="1"></energy-balance-chart>
    </vx-card>

    <vx-card class="mt-4">

      <vs-table stripe :data="operations" noDataText="Nenhum registro encontrado.">

        <template slot="thead">
          <th>Nome</th>
          <th>CNPJ</th>
          <th>ID Interno</th>
          <th>Início da Operação</th>
          <th>Vencimento da Operação</th>
          <th>Operação</th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :key="indextr" v-for="(row, indextr) in data">
            <td>
              <a role="button" style="cursor: pointer" @click="view(row)">{{row.clientName}}</a>
            </td>
            <td>
              {{(row.guarantor.cnpjAlfa || row.guarantor.cnpj) | formatCnpj}}
            </td>
            <td>
              {{row.idThunders}}
            </td>
            <td>
              {{row.operationStart | formatDate}}
            </td>
            <td>
              {{row.operationEnd | formatDate}}
            </td>
            <td>
              {{row.operationType | formatOperationType}}
            </td>
          </vs-tr>
        </template>

      </vs-table>

      <div class="my-5">
        <vs-pagination
          v-model="page"
          :total="totalPages">
        </vs-pagination>
      </div>

    </vx-card>

  </div>

</template>

<script>
import axios from 'axios'
import NumericInput from '@/components/NumericInput'
import VueApexCharts from 'vue-apexcharts'
import ptbr from 'apexcharts/dist/locales/pt-br.json'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/pt-br'
import EnergyBalanceChart from "@/components/stats/EnergyBalanceChart";

export default {
  components: {
    NumericInput,
    ptbr,
    VueApexCharts,
    DatePicker,
    EnergyBalanceChart
  },
  data () {
    return {
      values: {
        long: [],
        short: [],
        labels: [],
      },
      tipoOperacao: null,
      tipoOperacoes:
        [
          {
            name:'Todos',
            value: null
          },
          {
            name:'Compra',
            value: 'LONG'
          },
          {
            name:'Venda',
            value: 'SHORT'
          },
          {
            name:'Swap',
            value: 'SWAP'
          }
        ],
      portfolios: [],
      company: {
        name: '',
        cnpj: '',
        guid: ''
      },
      companies: [],
      cnpj: '',
      dates: [],
      idThunders: '',
      portfolio: { guid: null },
      energyOrPrice: false,
      operation: '',
      operations: [],
      energy: '',
      energyTypes: [
        {
          name: 'Todas',
          value: null
        },
        {
          name: 'Convencional',
          value: 'CONVENTIONAL'
        },
        {
          name: 'Incentivada 100%',
          value: 'I1'
        },
        {
          name: 'Incentivada 80%',
          value: 'I8'
        },
        {
          name: 'Incentivada 50%',
          value: 'I5'
        },
        {
          name: 'Incentivada 0%',
          value: 'I0'
        }
      ],
      market: '',
      markets: [
        {
          name: 'Todos',
          value: null
        },
        {
          name: 'Sul',
          value: 'SOUTH'
        },
        {
          name: 'Sudeste',
          value: 'SOUTHEAST'
        },
        {
          name: 'Norte',
          value: 'NORTH'
        },
        {
          name: 'Nordeste',
          value: 'NORTHEAST'
        }
      ],
      companyGuid: null,
      page: 1,
      totalPages: 0,
    }
  },
  watch: {
    page () {
      this.loadOperations()
    }
  },
  beforeMount () {
    this.portfolioDates()
  },
  methods: {

    loadNames () {
      axios.get(`${process.env.VUE_APP_API}/api/v1/operation/names`,
        {
          params: {
            portfolioDate: this.portfolio.portfolioDate
          }
        })
        .then((response) => {
          this.companies = response.data
        })
      .finally(()=>{
        this.loadOperations()
        this.loadChart()
      })
    },


    portfolioDates () {
      axios.get(`${process.env.VUE_APP_API  }/api/v1/portfolio`, {
        params: {
          limit: 9999,
          status: 'PROCESSED'
        }
      })
        .then((response) => {
          this.portfolios = response.data.content
          if (this.portfolios !== null && this.portfolios.length > 0) {
            this.portfolio = this.portfolios[0]
          }
        })
      .finally(() => {
        this.loadNames()
      })
    },

    refresh () {
      this.loadOperations()
      this.loadChart()
    },

    loadChart () {
      axios.get(`${process.env.VUE_APP_API  }/api/v1/operation-chart`,
        {
          params: {
            energy: this.energy,
            companyGuid: this.company.guid,
            idThunders: this.idThunders,
            market: this.market,
            operation: this.operation,
            tipoOperacao: this.tipoOperacao,
            portfolioGuid: this.portfolio.guid
          }
        })
        .then((response) => {
          let short = response.data[0]
          let long = response.data[1]
          this.values.long = short.data
          this.values.short = long.data
          this.values.labels = short.categories
        })
    },

    loadOperations () {
      if (this.portfolio.guid == null) return

      axios.get(`${process.env.VUE_APP_API  }/api/v1/operation`,
        {
          params: {
            cnpj: this.company.cnpj,
            energy: this.energy,
            market: this.market,
            idThunders: this.idThunders,
            name: this.company.name,
            portfolioGuid: this.portfolio.guid,
            tipoOperacao: this.tipoOperacao,
            page: this.page - 1
          }
        })
        .then((response) => {
          this.operations = response.data.content
          this.totalPages = response.data.totalPages
        })
    },

    view (row) {
      this.$router.push({path: `/operation/${  row.guid}`})
    },

    refine (company, idThunders, energy, market, portfolio, tipoOperacao) {
      this.company = company
      this.idThunders = idThunders
      this.energy = energy
      this.market = market
      this.portfolio = portfolio
      this.tipoOperacao = tipoOperacao
      this.page = 1
      this.refresh()
    },

    clearFilter () {
      this.energy = ''
      this.company.name = ''
      this.company.cnpj = null
      this.company.guid = ''
      this.market = ''
      this.idThunders = ''
      this.tipoOperacao = null
      this.page = 1
      this.refresh()
    }

  }
}
</script>

<style scoped>

</style>
